import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Log error for debugging but never redirect to /login
        console.error('[ErrorBoundary] Caught error:', error?.message, errorInfo?.componentStack?.split('\n')?.[1]);
    }

    handleReload = () => {
        // Reload the page in-place — preserves auth session in localStorage
        // Never redirect to /login as that destroys the session unnecessarily
        window.location.reload();
    };

    handleGoHome = () => {
        // Redirige a la raíz — App.js redireccionará dinámicamente según el rol del perfil
        window.history.pushState({}, '', '/');
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-background p-6">
                    <div className="max-w-md w-full text-center space-y-6">
                        <div className="w-16 h-16 mx-auto rounded-full bg-red-100 dark:bg-red-900/20 flex items-center justify-center">
                            <svg className="h-8 w-8 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                            </svg>
                        </div>
                        <div>
                            <h2 className="text-xl font-semibold text-foreground mb-2">
                                Algo salió mal
                            </h2>
                            <p className="text-muted-foreground text-sm">
                                Se produjo un error inesperado en esta página. Tu sesión está segura — recarga para continuar.
                            </p>
                        </div>
                        <div className="flex gap-3 justify-center">
                            <button
                                onClick={this.handleGoHome}
                                className="inline-flex items-center justify-center rounded-md border border-input bg-background px-5 py-2.5 text-sm font-medium text-foreground hover:bg-accent transition-colors"
                            >
                                Ir al inicio
                            </button>
                            <button
                                onClick={this.handleReload}
                                className="inline-flex items-center justify-center rounded-md bg-orange-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-orange-700 transition-colors"
                            >
                                Recargar página
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
